import DevelopmentGoals from "./DevelopmentGoals.jsx";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import CoreGoals from "./CoreGoals.jsx";
import Tabs from "@mui/material/Tabs";
import TabModal from "./TabModal.jsx";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import React from "react";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

function BasicTabs() {
    const theme = useTheme();
    const { t } = useTranslation();
    const [value, setValue] = React.useState(0);
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="tabs_box my-4">
            <div className="center_between my-3">
                <h3>{t("Reviews")}</h3>
                <TabModal />
            </div>
            <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider", marginBottom: "20px" }}>
                    <Tabs value={value} onChange={handleChange} aria-label="tabs" orientation={isSmallScreen ? "vertical" : "horizontal"}>
                        <Tab label={t("Performance")} {...a11yProps(0)} />
                        <Tab label={t("Development")} {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <CoreGoals />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <DevelopmentGoals />
                </TabPanel>
            </Box>
        </div>
    );
}

export default React.memo(BasicTabs);
